import EndorsmentSlider from '../../components/endorsments/endorsmentSlider';
export default EndorsmentSlider;